import { PeopleTypes } from "enums/peopleTypes";
import { useCopyRosterFromFixtureToFixture } from "hooks/useRosterCopyApi";
import { useCopyStaffFromFixtureToFixture } from "hooks/useStaffCopyApi";

type Props = {
  type: PeopleTypes;
  entityId: string;
  seasonId: string;
  fixtureId: string;
  fromFixtureId: string;
};

export const useCopyPeople = ({ type, entityId, seasonId, fixtureId, fromFixtureId }: Props) => {
  const { mutateAsync: copyRoster, isPending: isRosterCopying } = useCopyRosterFromFixtureToFixture();
  const { mutateAsync: copyStaff, isPending: isStaffCopying } = useCopyStaffFromFixtureToFixture();

  const mutateAsync =
    type === PeopleTypes.Roster
      ? () => copyRoster({ entityId, seasonId, fixtureId, fromFixtureId })
      : type === PeopleTypes.Staff
        ? () => copyStaff({ entityId, seasonId, fixtureId, fromFixtureId })
        : () => {};

  return { isCopying: isRosterCopying || isStaffCopying, mutateAsync };
};
